import axios from 'axios'

export default new class TestMethodService {
  get (notificationServiceId) {
    return axios.get('/notification-services/' + notificationServiceId)
  }

  getList () {
    return axios.get('/notification-services')
  }
}()
